import { render, staticRenderFns } from "./educationDivision6.vue?vue&type=template&id=30703677"
import script from "./educationDivision6.vue?vue&type=script&lang=js"
export * from "./educationDivision6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30703677')) {
      api.createRecord('30703677', component.options)
    } else {
      api.reload('30703677', component.options)
    }
    module.hot.accept("./educationDivision6.vue?vue&type=template&id=30703677", function () {
      api.rerender('30703677', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/div/educationDivision6.vue"
export default component.exports